import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection.ou-imported', {
        url: '/ou-imported',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageConnectionOuImported'
        },
        resolve: {
            domains,
        },
    });
}

/** @ngInject */
function domains(companyId, DirectoriesResource, directoryId) {
    return DirectoriesResource.getDomains(companyId, directoryId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/ou-imported/ou-imported.state.js